import {
  horaParaMinutos,
  minutosParaHora,
  normalizarHora,
} from "./horariosDisponibilidadeGrade";

export const DIAS_SEMANA = [
  ["segunda", "Segunda-feira"],
  ["terca", "Terça-feira"],
  ["quarta", "Quarta-feira"],
  ["quinta", "Quinta-feira"],
  ["sexta", "Sexta-feira"],
  ["sabado", "Sábado"],
  ["domingo", "Domingo"],
];

export const NOMES_DIAS = Object.fromEntries(DIAS_SEMANA);

export const DIAS_UTEIS = ["segunda", "terca", "quarta", "quinta", "sexta"];

export function gerarSlotsGrade({
  abertura,
  fechamento,
  intervaloMinutos = 30,
  horaInicio = null,
  horaFim = null,
}) {
  const aberturaMin = horaParaMinutos(abertura);
  const fechamentoMin = horaParaMinutos(fechamento);
  const inicioMin = horaParaMinutos(horaInicio || abertura);
  const fimMin = horaParaMinutos(horaFim || fechamento);
  const intervalo = intervaloMinutos > 0 ? intervaloMinutos : 30;

  if (
    aberturaMin == null ||
    fechamentoMin == null ||
    inicioMin == null ||
    fimMin == null
  ) {
    return [];
  }

  const limiteInicio = Math.max(aberturaMin, inicioMin);
  const limiteFim = Math.min(fechamentoMin, fimMin);

  if (limiteInicio >= limiteFim) return [];

  const slots = [];
  for (let atual = aberturaMin; atual < fechamentoMin; atual += intervalo) {
    if (atual >= limiteInicio && atual < limiteFim) {
      slots.push(minutosParaHora(atual));
    }
  }

  return slots;
}

export function indexarHorariosPorHora(itens = []) {
  const mapa = new Map();
  (itens || []).forEach((item) => {
    mapa.set(normalizarHora(item.hora), item);
  });
  return mapa;
}
